import styled from "styled-components";

import {
  DefaultParagraphLargeFactory,
  DefaultTitleSmallFactory,
  DefaultTitleXLargeFactory,
} from "components/common/Typograph/Typograph.Style";

export const SectionObjectiveContainer = styled.section(({ theme }) => ({
  backgroundColor: theme.color.brandPrimary.light,
  color: theme.color.neutral["08"],

  paddingTop: "40px",
  paddingBottom: "40px",

  [theme.breakpoint.xl()]: {
    paddingBottom: "60px",
    paddingTop: "60px",
  },
}));

export const SectionObjectiveContent = styled.div(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "40px",
}));

export const SectionObjectiveHeader = styled.div(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "40px",
}));

export const SectionObjectiveTitle = styled.h2(({ theme }) => ({
  ...DefaultTitleXLargeFactory({ theme }),
  margin: 0,
}));

export const SectionObjectiveDescription = styled.p(({ theme }) => ({
  ...DefaultParagraphLargeFactory({ theme }),
  margin: 0,
  fontWeight: 300,
}));

export const SectionObjectiveList = styled.div(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "0 40px",

  [theme.breakpoint.lg()]: {
    display: "grid",
    gridTemplateColumns: "repeat(2, 1fr)",
  },
}));

export const SectionObjectiveCard = styled.div(() => ({
  display: "flex",
  alignItems: "center",
  gap: "32px",

  svg: {
    flex: 1,
    width: "38px",
    height: "38px",
  },
}));

export const SectionObjectiveCardDescription = styled.p(({ theme }) => ({
  ...DefaultTitleSmallFactory({ theme }),
}));
